import { useEffect, useState } from "react";
import type { RdScheduleAppointmentType } from "../../../../../shared/rd-schedule-actions";
import {
  fetchAppointmentTypes,
  type ScheduleApi,
} from "../../../lib/rd-schedule-actions";

// NO-876. The video appointment types New appointment offers.
// `types` is null until the read lands; `failed` lets a dialog say so.

export function useAppointmentTypes(
  api: ScheduleApi,
  rdId: string | null
): { types: RdScheduleAppointmentType[] | null; failed: boolean } {
  const [types, setTypes] = useState<RdScheduleAppointmentType[] | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let current = true;

    fetchAppointmentTypes(api, rdId)
      .then((loaded) => {
        if (current) setTypes(loaded);
      })
      .catch(() => {
        if (!current) return;

        setTypes([]);
        setFailed(true);
      });

    return () => {
      current = false;
    };
  }, [api, rdId]);

  return { types, failed };
}
